import React from 'react';
import { BookOpenIcon, CheckCircle2Icon, FileTextIcon, GiftIcon, TrophyIcon, XCircleIcon } from 'lucide-react';
const painPoints = ['Antes de cada sesión, no recuerdas el orden exacto de las herramientas y terminas improvisando.', 'Sabes hacer maderoterapia, pero no cómo estructurar una sesión de 30, 45 o 60 minutos.', 'Usas siempre el mismo protocolo porque no tienes otros documentados.', 'Tu cliente pregunta cuántas sesiones necesita y no sabes qué responder con seguridad.', 'Tienes herramientas de madera, pero no las usas todas porque no sabes bien para qué sirve cada una.', 'Tus clientes mejoran, pero no lo ven, y no vuelven después de dos sesiones.', 'No sabes cómo armar un menú de servicios ni qué precio ponerle a cada uno.', 'Terminas buscando “protocolo maderoterapia abdomen” la noche antes de una sesión.'];
const tomes = [['TOMO 1', 'Fundamentos, Anatomía y Herramientas', 'La base científica y técnica: historia, anatomía del tejido, función de cada herramienta, reglas de oro y protocolo base universal de 60 minutos.'], ['TOMO 2', 'Esculpido Corporal y Estética', 'Protocolos de abdomen, flancos, piernas, cartucheras y glúteos con orden, tiempos, presión y cierre linfático. Incluye medición y fotografía de progreso.'], ['TOMO 3', 'Maderoterapia Terapéutica', 'Liberación miofascial con madera, protocolos para contracturas cervicales y dorsales, zona lumbar, puntos gatillo y deportistas post-entrenamiento.'], ['TOMO 4', 'Drenaje Linfático y Post-Parto', 'Drenaje con madera, retención de líquidos y protocolo post-parto con criterios de seguridad, diástasis, plan de 12 sesiones y consentimiento.'], ['TOMO 5', 'Diseño de Sesiones y Programas', 'Cronogramas de 30, 45, 60 y 90 minutos, programas de 8 y 12 sesiones, menú de servicios, precios sugeridos y rentabilidad.'], ['TOMO 6', 'Marketing, Negocio y Gestión', 'Lanzamiento en 7 días, redes sociales, contenido mensual, administración, fichas y un plan de acción para tus primeros 90 días.']];
const bonuses = [['Mapa Express de Protocolos por Objetivo', '$19', 'Encuentra en segundos qué protocolo usar según el objetivo del cliente. Incluye tabla rápida, selector de 3 preguntas y versión móvil.'], ['Checklist Pro de Seguridad y Preparación de Sesión', '$19', 'Prepara cada sesión con semáforo de seguridad, escala de presión y guion de bienvenida profesional.'], ['Agenda 21 Días para Lanzar tu Servicio de Maderoterapia', '$19', 'Organiza, publica y deja listo tu servicio para vender con tareas simples de 10 a 30 minutos al día.'], ['Pack de Fichas Profesionales para Clientes Wellness', '$19', 'Ficha inicial, registro de medidas, evolución subjetiva, consentimiento y recomendaciones post-sesión.'], ['Guiones de WhatsApp e Instagram para Vender Maderoterapia', '$21', '25 guiones, respuestas a objeciones, captions y textos para historias listos para copiar y pegar.']];
export function Features() {
  return <div className="w-full bg-white" data-id="element-5">
      <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-20" data-id="element-6">
        <div className="mx-auto max-w-3xl text-center" data-id="element-7">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-8">
            Reconoce el problema
          </p>
          <h2 className="mt-3 text-3xl font-black tracking-tight text-brand-900 md:text-4xl" data-id="element-9">
            Si eres profesional del bienestar, seguramente estás lidiando con
            alguno de estos problemas
          </h2>
        </div>
        <div className="mt-9 grid gap-3 md:grid-cols-2" data-id="element-10">
          {painPoints.map(point => <div key={point} className="flex gap-3 rounded-xl border border-brand-100 bg-cream p-4" data-id="element-11">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-12" />
              <p className="text-sm font-medium leading-relaxed text-gray-700" data-id="element-13">
                {point}
              </p>
            </div>)}
        </div>
        <p className="mt-10 text-center text-2xl font-black text-brand-600 md:text-3xl" data-id="element-14">
          ¿Y si todo esto ya estuviera hecho por ti?
        </p>
      </section>

      <section className="bg-brand-900 px-4 py-12 text-white sm:px-6 md:py-20" data-id="element-15">
        <div className="mx-auto max-w-6xl text-center" data-id="element-16">
          <div className="inline-flex items-center gap-2 rounded-full bg-brand-800 px-4 py-2 text-xs font-bold tracking-wide text-accent" data-id="element-17">
            <TrophyIcon className="h-4 w-4" data-id="element-18" /> EL SISTEMA MÁS COMPLETO EN
            ESPAÑOL
          </div>
          <h2 className="mt-5 text-3xl font-black md:text-5xl" data-id="element-19">
            MEGAPACK MADEROTERAPIA PRO™
          </h2>
          <p className="mt-3 text-lg font-semibold text-brand-100 md:text-2xl" data-id="element-20">
            6 Tomos + 5 Bonos — Del primer contacto al sistema de negocio
            completo
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-gray-300 md:text-base" data-id="element-21">
            Más de 300 páginas de protocolos listos, fichas, guiones y material
            de gestión profesional — todo hecho por ti.
          </p>
          <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-4" data-id="element-22">
            {[['300+', 'páginas', FileTextIcon], ['20+', 'protocolos listos', BookOpenIcon], ['8', 'herramientas dominadas', TrophyIcon], ['Fichas', 'imprimibles incluidas', CheckCircle2Icon]].map(([value, label, Icon]) => {
            const StatIcon = Icon as typeof FileTextIcon;
            return <div key={label as string} className="rounded-xl bg-brand-800/70 p-4" data-id="element-23">
                  <StatIcon className="mx-auto h-6 w-6 text-accent" data-id="element-24" />
                  <p className="mt-2 font-black" data-id="element-25">{value}</p>
                  <p className="text-xs text-brand-100" data-id="element-26">{label}</p>
                </div>;
          })}
          </div>
          <p className="mt-7 text-sm font-medium leading-loose text-brand-100" data-id="element-27">
            Fundamentos · Esculpido corporal · Terapéutica muscular · Drenaje y
            post-parto · Sesiones y programas · Negocio y gestión
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-20" data-id="element-28">
        <div className="text-center" data-id="element-29">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-30">
            Tu biblioteca de consulta
          </p>
          <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-31">
            Los 6 Tomos Completos
          </h2>
        </div>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-32">
          {tomes.map(([number, title, description], index) => <article key={number} className={`rounded-2xl border p-6 ${index === 2 ? 'border-accent bg-accent/5' : 'border-brand-100 bg-white'}`} data-id="element-33">
              <p className="text-xs font-black tracking-[0.14em] text-brand-600" data-id="element-34">
                {number}
                {index === 2 ? ' · EL TOMO QUE TE DIFERENCIA' : ''}
              </p>
              <h3 className="mt-2 text-xl font-black text-brand-900" data-id="element-35">
                {title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-gray-600" data-id="element-36">
                {description}
              </p>
            </article>)}
        </div>
        <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-2 rounded-xl border border-brand-100 bg-cream p-5 text-xs font-semibold text-brand-800" data-id="element-37">
          {['Protocolos completos listos para usar', 'Fichas imprimibles y digitales', 'Checklists paso a paso', 'Material entregable al cliente', 'Consultable desde tablet o celular'].map(item => <span key={item} className="flex items-center gap-1.5" data-id="element-38">
              <CheckCircle2Icon className="h-4 w-4 text-brand-500" data-id="element-39" />
              {item}
            </span>)}
        </div>
      </section>

      <section className="bg-brand-50 px-4 py-12 sm:px-6 md:py-20" data-id="element-40">
        <div className="mx-auto max-w-5xl" data-id="element-41">
          <div className="text-center" data-id="element-42">
            <p className="text-sm font-bold text-brand-600" data-id="element-43">
              Incluidos sin costo extra — Valor total: $97 →{' '}
              <span className="text-brand-900" data-id="element-44">GRATIS con tu MegaPack</span>
            </p>
            <h2 className="mt-3 text-3xl font-black text-brand-900 md:text-4xl" data-id="element-45">
              Los 5 Bonos Estratégicos
            </h2>
          </div>
          <div className="mt-9 space-y-3" data-id="element-46">
            {bonuses.map(([title, value, description], index) => <article key={title} className="flex gap-4 rounded-xl border border-brand-100 bg-white p-5" data-id="element-47">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent/15" data-id="element-48">
                  <GiftIcon className="h-5 w-5 text-accent" data-id="element-49" />
                </div>
                <div data-id="element-50">
                  <p className="text-xs font-bold text-brand-600" data-id="element-51">
                    BONO 0{index + 1} ·{' '}
                    <span className="text-gray-400 line-through" data-id="element-52">{value}</span>{' '}
                    · GRATIS
                  </p>
                  <h3 className="mt-1 text-base font-black text-brand-900" data-id="element-53">
                    {title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-gray-600" data-id="element-54">
                    {description}
                  </p>
                </div>
              </article>)}
          </div>
        </div>
      </section>
    </div>;
}